import { useEffect } from 'react';

import { useAttachmentUploader } from 'my-core/hooks';

import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

const rootCss = ({ spacing }) => ({
  marginLeft: spacing(1),
  '.AUM-progress': { marginRight: spacing(0.5) },
});

/**
 * Uploads the files dropped or pasted into a chat composer, reporting each as it lands.
 *
 * @param onUpload called with the attachment and how many uploads are still to come.
 * @param onUploadFail called with how many uploads are still to come; the failure itself is shown.
 */
export default function AttachmentUploadManager({ files, onUpload, onUploadFail }) {
  const { uploadFiles, uploads } = useAttachmentUploader({
    errorMessage: true,
    onUploadComplete: attachment => onUpload(attachment, uploads.length),
    onUploadFail: () => onUploadFail?.(uploads.length),
  });

  useEffect(() => {
    if (files) uploadFiles(files);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [files]);

  return (
    <div css={rootCss}>
      {uploads.map(item => (
        <Typography key={item.cId} noWrap variant="caption">
          <CircularProgress className="AUM-progress" size={9} value={parseInt(item.progress)} variant="determinate" />
          Uploading {item.file.name} ...
        </Typography>
      ))}
    </div>
  );
}
